import * as utils from "../../utils/utils.js";

export default function () {
  const widgetName = "fnCardWidget";
  const widgetOpts = fnCardWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ["all"],
    maxItemsVisible: 9,
    itemsPerPanel: 1,
    hasImages: true,
    imageIsBackground: true,
    lazyLoadImages: true,
    showDescription: false,
    textOverImage: true,
    buyNowButton: false,
    moreButton: false,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(`#${widgetName}`).remove();
      } else {
        createCustomCards(data.items);
      }
    },
  });

  function createCustomCards(widgetData) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      const { Title, URL, ImageWithPath, ImageAlternateText } = widgetData[x];
      const $cardElement = $(this);
      const targetUrl = !utils.isLocalUrl(URL) && URL ? "target='_blank'" : "";

      $cardElement.replaceWith(`
        <a ${
          URL ? `href="${URL}"` : ""
        } class="card-element${!URL ? " void-link" : ""}" ${targetUrl}>
          <div class="image-container" data-background-image="${ImageWithPath}" aria-label="${ImageAlternateText}" style="background-image:url('${ImageWithPath}')"></div>
          <div class="overlay"></div>
          <h2 class="card-widget-title"><span>${Title}</span></h2>
        </a>
        `);
    });
  }
}
